import { Injectable, inject } from '@angular/core'
import { IndexedDbService } from '@educational-initiatives/angular-web-utilities'
import { IndexDBConstants } from '../../constants/valueConstants'
import { UserPermissions } from '@app/core/models/user.model'

@Injectable({
    providedIn: 'root',
})
export class IndexDBHelper {
    private readonly indexedDbService = inject(IndexedDbService)

    async setPermissions(permissions: unknown, subAppId: string): Promise<void> {
        await this.indexedDbService.put(IndexDBConstants.PERMISSIONS_STORE_KEY, {
            id: subAppId,
            data: permissions,
        })
    }

    async getUserPreferences(subAppId: string): Promise<UserPermissions> {
        const result = await this.indexedDbService.get<{ id: string; data: UserPermissions }>(
            IndexDBConstants.PERMISSIONS_STORE_KEY,
            subAppId,
        )
        return result?.data as UserPermissions
    }

    /**
     * Clears persisted permissions (IndexedDB) for the current browser.
     * We do this on logout to avoid stale permission bits being reused by another user.
     */
    async clearPermissions(): Promise<void> {
        await this.indexedDbService.clear(IndexDBConstants.PERMISSIONS_STORE_KEY)
    }
}
